/**
 * Values corresponds to KeyboardEvent.key values
 */
export const KEYBOARD = {
    TAB: 'Tab',
    ESC: 'Escape',
    ENTER: 'Enter',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
};
